import React from 'react';
import { graphql } from "gatsby";

import Layout from '../../components/Layout';
import Title from '../../components/Title';
import BlogPostItem from '../../components/Blog-Post-Item';

const BlogPage = ({data}) => {
  const posts = data.allStrapiBlogPost.nodes;
  // const firstPost = posts.shift();

  return (
    <Layout title="Latest News">
      <Title>Latest News</Title>
      <div className="py-12 bg-white">
        <div className="container mx-auto px-12 grid sm:grid-cols-3 gap-8">
          {posts.map(post => (
            <BlogPostItem
              key={post.Slug}
              content={post.Content}
              coverImage={post.CoverImage}
              tag={post.BlogCategory.Title}
              title={post.Title}
              url={post.Slug}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query BlogPageQuery {
    allStrapiBlogPost(sort: {fields: updated_at, order: ASC}) {
      nodes {
        Slug
        CoverImage {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(aspectRatio: 1.8)
            }
          }
        }
        Title
        BlogCategory {
          Title
        }
        Content
      }
    }
  }
`;

export default BlogPage;